import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

export const useGetExportTicket = () => {
  const mutate = useMutation(() => {
    return get(`/enterprise-tickets-api/export_enterprise_tickets_excel`, {
      responseType: 'blob',
    });
  });

  return mutate;
};

export default useGetExportTicket;
